/* VL Games · "Build their game" builder (GIFT_BUILDER_SPEC.md). No dependencies.
   State: localStorage vlgift_build (14 days, no PII in URLs). Preview: vl-games.com preview.html via postMessage,
   stills first, live 3D crossfades in; stills fallback (no WebGL / slow / low memory / save-data / reduced motion). */
(function () {
  'use strict';
  var root = document.querySelector('[data-vgb]');
  if (!root || root.__vgb) return; root.__vgb = 1;
  var CFG = {}; try { CFG = JSON.parse(document.querySelector('[data-vgb-cfg]').textContent); } catch (e) { CFG = {}; }
  var $ = function (s, r) { return (r || root).querySelector(s); }, $$ = function (s, r) { return [].slice.call((r || root).querySelectorAll(s)); };
  var QS; try { QS = new URLSearchParams(location.search); } catch (e) { QS = { get: function () { return null; } }; }
  var reduce = false; try { reduce = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var KEY = 'vlgift_build', KEY_CFG = 'vlgift_cfg', TTL = 14 * 864e5;
  function sget(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function sset(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode: builder still works */ } }
  function sdel(k) { try { localStorage.removeItem(k); } catch (e) {} }
  function ev(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // ---------------- data ----------------
  var CARDS = {
    partner: { aud: 'partner', g: '', label: 'Partner', to: 'Anna', from: 'Mike', tagFrom: 'you', col: 'hearts', hint: 'First name or nickname is perfect.' },
    girl: { aud: 'kid', g: 'girl', label: 'Girl', to: 'Sofia', from: 'Mom & Dad', tagFrom: 'Mom & Dad', col: 'hearts', hint: 'First name or nickname only.' },
    boy: { aud: 'kid', g: 'boy', label: 'Boy', to: 'Max', from: 'Mom & Dad', tagFrom: 'Mom & Dad', col: 'stars', hint: 'First name or nickname only.' },
    kid: { aud: 'kid', g: '', label: 'Kid', to: 'Sofia', from: 'Mom & Dad', tagFrom: 'Mom & Dad', col: 'stars', hint: 'First name or nickname only.' },
    teen: { aud: 'teen', g: '', label: 'Teen', to: 'Jake', from: 'Mom & Dad', tagFrom: 'Mom & Dad', col: 'stars', hint: 'First name or nickname only.' },
    family: { aud: 'family', g: '', label: 'Family', to: 'Grandma', from: 'all of us', tagFrom: 'all of us', col: 'hearts', hint: 'A name or what you call them — “Grandma” works.' },
    friend: { aud: 'friend', g: '', label: 'Friend', to: 'Sam', from: 'Alex', tagFrom: 'Alex', col: 'hearts', hint: 'First name or nickname is perfect.' }
  };
  var REL = { grandma: 'Grandma', grandpa: 'Grandpa', mom: 'Mom', dad: 'Dad', sibling: '', other: '' };
  var OPTS = [
    { k: 'collectible', prop: 'Collectible', t: 'They collect', o: [['hearts', 'Hearts', 'heart'], ['stars', 'Gold stars', 'star'], ['snowflakes', 'Snowflakes', 'flake'], ['presents', 'Presents', 'gift']] },
    { k: 'tree', prop: 'Tree', t: 'Christmas tree', o: [['classic', 'Classic', ['#1f6b45', '#e0283f', '#ffd25a']], ['snowy', 'Snowy', ['#3d6f7a', '#e8f2ff', '#9cc8ff']], ['pinkgold', 'Pink & Gold', ['#d97a9c', '#ffd25a', '#fff1e0']]] },
    { k: 'outfit', prop: 'Outfit', t: 'Their jacket', o: [['red', 'Red', '#c8283c'], ['blue', 'Blue', '#2f5fc8'], ['green', 'Green', '#1f7a4a'], ['purple', 'Purple', '#7a3fb0']] },
    { k: 'sky', prop: 'Sky', t: 'Sky', o: [['aurora', 'Northern lights', 'linear-gradient(160deg,#0b1d3a 10%,#1fd6a0 45%,#8a5cff 70%,#1c2a5a)'], ['starry', 'Starry night', 'radial-gradient(1.5px 1.5px at 30% 30%,#fff 50%,transparent 60%),radial-gradient(1.5px 1.5px at 70% 55%,#fff 50%,transparent 60%),linear-gradient(160deg,#120c33,#3a2a6e)'], ['snowfall', 'Snowfall', 'radial-gradient(2px 2px at 25% 35%,#fff 50%,transparent 60%),radial-gradient(2px 2px at 65% 65%,#fff 50%,transparent 60%),linear-gradient(170deg,#5b4a6e,#b98a8a)']] },
    { k: 'sleigh', prop: 'Sleigh', t: 'Sleigh & reindeer', o: [['classic', 'Classic', ['#8a5a34', '#b5272f', '#a7adb6', 'Classic wooden sleigh']], ['emerald', 'Emerald', ['#2f7a4c', '#a8263a', '#f2c14e', 'Emerald and gold sleigh']], ['royal', 'Royal', ['#f2c14e', '#a8263a', '#f4efe6', 'Royal gold and ivory sleigh']], ['candycane', 'Candy cane', ['cc', '#db2a3a', '#f2c14e', 'Red and white candy-cane sleigh']]] },
    { k: 'music', prop: 'Music', t: 'Music', o: [['jingle', 'Jingle Bells'], ['cheerful', 'Deck the Halls'], ['wewish', 'We Wish You a Merry Christmas'], ['lullaby', 'Silent Night'], ['joy', 'Joy to the World'], ['wenceslas', 'Good King Wenceslas'], ['twinkle', 'Twinkle Twinkle']] }
  ];
  var DEF = { collectible: 'hearts', tree: 'classic', outfit: 'red', sky: 'aurora', music: 'jingle', sleigh: 'classic' };
  var ICON = {
    heart: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#ff5d8f" d="M12 21s-7.5-4.6-9.6-9.2C.9 8.4 3 4.5 6.7 4.5c2.2 0 3.6 1.2 5.3 3.1 1.7-1.9 3.1-3.1 5.3-3.1 3.7 0 5.8 3.9 4.3 7.3C19.5 16.4 12 21 12 21z"/></svg>',
    star: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#ffc83d" stroke="#d99a1e" stroke-width=".8" d="M12 2.5l2.9 6.2 6.6.7-5 4.5 1.4 6.6L12 17.2l-5.9 3.3 1.4-6.6-5-4.5 6.6-.7z"/></svg>',
    flake: '<svg viewBox="0 0 24 24" aria-hidden="true"><g stroke="#7cc4ff" stroke-width="2" stroke-linecap="round" fill="none"><path d="M12 2v20M3.3 7l17.4 10M3.3 17L20.7 7"/><path d="M9.5 3.8L12 6l2.5-2.2M9.5 20.2L12 18l2.5 2.2"/></g></svg>',
    gift: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="9" width="18" height="12" rx="2" fill="#e0284f"/><rect x="2" y="7" width="20" height="4" rx="1.5" fill="#f2425f"/><path fill="#ffd25a" d="M10.6 7h2.8v14h-2.8z"/><path fill="none" stroke="#ffd25a" stroke-width="1.8" d="M12 7c-1.5-3.5-5-4-5-1.8C7 7 12 7 12 7zm0 0c1.5-3.5 5-4 5-1.8C17 7 12 7 12 7z"/></svg>'
  };
  // sleigh swatch: body, seat, runners (+ candy-cane stripes); colours follow the engine's sleigh looks (runner setpieces.js)
  function sleighSvg(c) {
    var body = c[0] === 'cc' ? 'url(#vgb-cc)' : c[0];
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' + (c[0] === 'cc' ? '<defs><pattern id="vgb-cc" width="4" height="4" patternUnits="userSpaceOnUse" patternTransform="rotate(40)"><rect width="4" height="4" fill="#fff"/><rect width="2" height="4" fill="#db2a3a"/></pattern></defs>' : '') +
      '<rect x="3.2" y="4.6" width="5" height="4.6" rx="1.4" fill="' + c[1] + '"/>' +
      '<path d="M2.6 8.4h5.6l1.2 4.1h8.3c1.3 0 2.3-1 2.3-2.3V8.6h1.8v1.9a4.2 4.2 0 0 1-4.2 4.2H8.1a1.7 1.7 0 0 1-1.6-1.2z" fill="' + body + '" stroke="rgba(0,0,0,.25)" stroke-width=".5"/>' +
      '<path d="M8.6 14.7v3.4M16.4 14.7v3.4M2.5 18.4h16a3 3 0 0 0 3-3" fill="none" stroke="' + c[2] + '" stroke-width="1.7" stroke-linecap="round"/></svg>';
  }
  function treeSvg(c) { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="' + c[0] + '" d="M12 2l4.2 6h-2.4l4.6 6h-2.6l5 7H3.2l5-7H5.6l4.6-6H7.8z"/><circle cx="9" cy="16" r="1.3" fill="' + c[1] + '"/><circle cx="14.5" cy="12" r="1.2" fill="' + c[2] + '"/><circle cx="15.5" cy="17.5" r="1.3" fill="' + c[1] + '"/></svg>'; }
  var BADGE = {
    game: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    voice: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="9" y="3" width="6" height="11" rx="3" fill="currentColor"/><path d="M6 11a6 6 0 0 0 12 0M12 17v4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    duo: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="8" cy="8" r="3.2" fill="currentColor"/><circle cx="16.5" cy="8" r="3.2" fill="currentColor"/><path d="M2.5 20c.5-4 2.6-6 5.5-6s5 2 5.5 6M11 20c.4-4 2.6-6 5.5-6s5 2 5.5 6" fill="currentColor"/></svg>',
    video: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2.5" y="5.5" width="13" height="13" rx="3" fill="currentColor"/><path d="M16.5 10.5l5-3v9l-5-3z" fill="currentColor"/></svg>'
  };
  var VAR = {};
  $$('[data-eds] input').forEach(function (i) { VAR[i.value] = { id: +i.getAttribute('data-vid'), price: +i.getAttribute('data-price'), title: i.getAttribute('data-title'), el: i }; });
  var RUSH = $('[data-rush]'), RUSH_P = RUSH ? +RUSH.getAttribute('data-price') : 0;
  function money(c) { var d = c / 100; return '$' + (d % 1 ? d.toFixed(2) : d.toFixed(0)); }
  var NAME_RX = /[^\p{L}\p{M} '&.\-]/gu, FROM_RX = /[^\p{L}\p{M}\p{N} '&.,\-]/gu;
  try { new RegExp('\\p{L}', 'u'); } catch (e) { NAME_RX = /[^A-Za-zÀ-ɏЀ-ӿ '&.\-]/g; FROM_RX = /[^A-Za-z0-9À-ɏЀ-ӿ '&.,\-]/g; }
  function cleanName(v) { return String(v || '').replace(NAME_RX, '').replace(/\s+/g, ' ').replace(/^\s+/, '').slice(0, 14); }
  function cleanFrom(v) { return String(v || '').replace(FROM_RX, '').replace(/\s+/g, ' ').replace(/^\s+/, '').slice(0, 20); }

  // ---------------- state ----------------
  var st = { v: 1, step: 1, card: '', aud: 'partner', g: '', rel: '', to: '', from: '', opts: Object.assign({}, DEF), colTouched: false, tier: 'deluxe', rush: false, at: 0 };
  var dirty = false, resumed = false;
  var saved = sget(KEY);
  if (saved && saved.v === 1 && saved.at && Date.now() - saved.at < TTL) {
    Object.keys(st).forEach(function (k) { if (saved[k] != null) st[k] = saved[k]; });
    st.opts = Object.assign({}, DEF, saved.opts || {});
    st.to = cleanName(st.to); st.from = cleanFrom(st.from);
    if (st.step >= 2 && st.card) resumed = true; else st.step = 1;
  } else if (saved) sdel(KEY);
  if (!CARDS[st.card]) { st.card = ''; if (st.step > 1) st.step = 1; }
  if (!VAR[st.tier]) st.tier = VAR.deluxe ? 'deluxe' : Object.keys(VAR)[0];
  // deep links: ?for= (skips step 1), ?tier=, ?from=grandparents (preset, not a name), ?step=
  var qFor = (QS.get('for') || '').toLowerCase(); if (qFor === 'kids' || qFor === 'child') qFor = 'kid'; if (qFor === 'grandparents') qFor = 'family';
  var qTier = (QS.get('tier') || '').toLowerCase(), qFrom = (QS.get('from') || '').toLowerCase();
  if (CARDS[qFor]) {
    var same = st.card === qFor || (qFor === 'kid' && (st.card === 'girl' || st.card === 'boy'));
    if (!(resumed && same)) { if (st.card && !same) st.to = ''; resumed = false; pickCard(qFor, true); st.step = 2; }
  }
  if (VAR[qTier]) st.tier = qTier;
  if (qFrom === 'grandparents' && !st.from) st.from = 'Grandma & Grandpa';
  var qStep = parseInt(QS.get('step'), 10); if (qStep >= 1 && qStep <= 4 && (qStep === 1 || st.card)) st.step = qStep;
  var saveT = 0;
  function save() {
    dirty = true; st.at = Date.now();
    clearTimeout(saveT); saveT = setTimeout(function () {
      sset(KEY, st); sset(KEY_CFG, { v: 1, opts: st.opts, at: st.at });
    }, 300);
  }
  function card() { return CARDS[st.card] || CARDS.partner; }
  function relName() { return REL[st.rel] || ''; }
  function toPh() { return st.aud === 'family' && relName() ? relName() : card().to; }
  function fromPh() { return card().tagFrom; }
  function autoCol() { if (st.aud === 'kid' || st.aud === 'teen') return st.g === 'girl' ? 'hearts' : 'stars'; return 'hearts'; }
  function pickCard(c, quiet) {
    var prev = st.card; st.card = c; st.aud = CARDS[c].aud;
    if (CARDS[c].g || st.aud === 'partner' || st.aud === 'family' || st.aud === 'friend') st.g = CARDS[c].g;
    if (st.aud !== 'family') st.rel = '';
    if (!st.colTouched) st.opts.collectible = autoCol();
    if (prev && prev !== c && CARDS[prev].aud !== st.aud && !quiet) { /* audience changed: keep the typed name */ }
  }

  // ---------------- build the option rows (step 3) ----------------
  (function () {
    var h = '';
    OPTS.forEach(function (g) {
      h += '<div class="vgb-opt"><p class="vgb-mini" id="vgb-o-' + g.k + '">' + esc(g.t) + (g.k === 'music' ? ' <span class="vgb-hear" data-hear>· tap to hear</span>' : '') + '</p>' +
        '<div class="vgb-chiprow vgb-chiprow--scroll" role="radiogroup" aria-labelledby="vgb-o-' + g.k + '" data-row="' + g.k + '">';
      g.o.forEach(function (o) {
        var vis = g.k === 'collectible' ? '<span class="vgb-ico">' + ICON[o[2]] + '</span>' : g.k === 'tree' ? '<span class="vgb-ico">' + treeSvg(o[2]) + '</span>' :
          g.k === 'outfit' ? '<span class="vgb-dot" style="background:' + o[2] + '"></span>' : g.k === 'sky' ? '<span class="vgb-sw" style="background:' + o[2] + '"></span>' : g.k === 'sleigh' ? '<span class="vgb-ico vgb-ico--sl">' + sleighSvg(o[2]) + '</span>' : '<span class="vgb-note-ic" aria-hidden="true">♪</span>';
        h += '<button type="button" role="radio" aria-checked="false" class="vgb-chip vgb-chip--opt" data-k="' + g.k + '" data-v="' + o[0] + '">' + vis + '<span>' + esc(o[1]) + '</span></button>';
      });
      h += '</div></div>';
    });
    $('[data-opts]').innerHTML = h;
  })();
  function optLabel(k, v) { var g = OPTS.filter(function (x) { return x.k === k; })[0], o = g && g.o.filter(function (x) { return x[0] === v; })[0]; return o ? o[1] : v; }

  // ---------------- preview: stills + live iframe ----------------
  var pv = $('[data-pv]'), liveBox = $('[data-live]'), frame = null, live = false, mode = 'still', pvReady = false, fpsLow = 0, fpsN = 0, readyT = 0;
  var stillA = $('[data-still="a"]'), stillB = $('[data-still="b"]'), stillKey = '';
  function stillUrl() { var k = st.opts.tree + '-' + st.opts.sky + '-' + st.opts.collectible; return (CFG.stills || {})[k] || ''; }
  function setStill(instant) {
    var u = stillUrl(); if (!u || u === stillKey) return; stillKey = u;
    var on = stillA.classList.contains('is-on') ? stillA : stillB, off = on === stillA ? stillB : stillA;
    if (instant || !on.getAttribute('src')) { on.src = u; return; }
    var im = new Image(); im.onload = im.onerror = function () { if (stillKey !== u) return; off.src = u; off.classList.add('is-on'); on.classList.remove('is-on'); }; im.src = u;
  }
  function post(msg) { if (frame && frame.contentWindow) try { frame.contentWindow.postMessage(msg, CFG.previewOrigin || '*'); } catch (e) {} }
  var nameT = 0;
  function postCfg(withName) {
    var o = Object.assign({}, st.opts, { audience: st.aud });
    if (withName) o.to = st.to;
    post({ type: 'vlcfg', opts: o });
  }
  function postName() { clearTimeout(nameT); nameT = setTimeout(function () { post({ type: 'vlcfg', opts: { to: st.to } }); }, 250); }
  function fallback(reason, userCanPlay) {
    if (frame) { frame.remove(); frame = null; }
    live = false; mode = 'still'; clearTimeout(readyT);
    pv.classList.remove('is-live'); pv.classList.add('is-still');
    $('[data-fbov]').hidden = false; updFb();
    $('[data-playpv]').hidden = !userCanPlay;
    root.setAttribute('data-pv-reason', reason); ev('preview_mode', { mode: 'fallback', reason: reason });
  }
  var showT = 0;
  /* capable = WebGL2 + (deviceMemory >= 3 or unknown, e.g. every iPhone): the live 3D preview starts at once, the still is only
     its loading placeholder; reduced motion / Save-Data do not block it (it is muted until a tap and pauses offscreen) */
  var CAPABLE = (function () {
    try { var c = document.createElement('canvas'), gl = c.getContext('webgl2'); if (!gl) return false; var lc = gl.getExtension('WEBGL_lose_context'); if (lc) lc.loseContext(); } catch (e) { return false; }
    var mem = navigator.deviceMemory; return mem == null || mem >= 3;
  })();
  function hasWebGL() { try { var c = document.createElement('canvas'); return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl'))); } catch (e) { return false; } }
  function startLive(force) {
    if (frame) return;
    mode = 'live'; $('[data-playpv]').hidden = true; $('[data-fbov]').hidden = true; pv.classList.remove('is-still');
    var base = CFG.preview || 'https://vl-games.com/gift/runner/preview.html';
    try { CFG.previewOrigin = new URL(base, location.href).origin; } catch (e) { CFG.previewOrigin = '*'; }
    var q = 'o=demo&ui=builder&dpr=1&' + Object.keys(st.opts).map(function (k) { return k + '=' + encodeURIComponent(st.opts[k]); }).join('&');
    frame = document.createElement('iframe');
    frame.title = 'Live preview of their game'; frame.setAttribute('allow', 'autoplay'); frame.setAttribute('tabindex', '-1');
    frame.src = base + (base.indexOf('?') < 0 ? '?' : '&') + q;
    liveBox.appendChild(frame);
    /* WebGL / load failure: no "ready" from the preview -> stills (capable phones get longer: first visit = download + shader compile) */
    readyT = setTimeout(function () { if (!pvReady && !force) fallback('timeout', true); }, CAPABLE ? 25000 : 8000);
    window.__vgbForce = !!force;
  }
  window.addEventListener('message', function (e) {
    if (!frame || e.source !== frame.contentWindow || !e.data || e.data.type !== 'vlpreview') return;
    if (e.data.ready) {
      pvReady = true; clearTimeout(readyT); postCfg(true);
      /* the preview renders its first frame on the next animation frame after "ready": crossfade from the still then */
      clearTimeout(showT); showT = setTimeout(showLive, 600);
    }
    if (typeof e.data.fps === 'number') { root.setAttribute('data-fps', e.data.fps); if (e.data.fps >= 10) showLive(); }
    if (typeof e.data.fps === 'number' && !window.__vgbForce) {
      fpsN++; if (fpsN < 2) return;   // the first 2-s report includes shader warm-up
      /* one full 2-s window under 20 fps -> stills (capable phones); older devices keep the 2-strike rule */
      fpsLow = e.data.fps < 20 && !document.hidden ? fpsLow + 1 : 0;
      if (fpsLow >= (CAPABLE ? 1 : 2)) fallback('fps', true);
    }
  });
  function showLive() { clearTimeout(showT); if (!frame || live) return; pv.classList.add('is-live'); live = true; ev('preview_mode', { mode: 'live' }); }
  $('[data-playpv]').addEventListener('click', function () { pvReady = false; startLive(true); });
  function initPreview() {
    setStill(true);
    var force = QS.get('pv');
    if (force === 'still') return fallback('forced', true);
    var mem = navigator.deviceMemory, conn = navigator.connection || {};
    if (!hasWebGL()) return fallback('nowebgl', false);
    if (CAPABLE || force === 'live') { root.setAttribute('data-pv-cap', CAPABLE ? '1' : '0'); return startLive(force === 'live'); }
    if (force !== 'live') {
      if (mem && mem <= 2) return fallback('memory', true);
      if (conn.saveData) return fallback('savedata', true);
      if (reduce) return fallback('reducedmotion', true);
    }
    var go = function () { startLive(force === 'live'); };
    if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 300 }); else setTimeout(go, 120);
  }
  function updFb() {
    var o = OPTS[2].o.filter(function (x) { return x[0] === st.opts.outfit; })[0] || OPTS[2].o[0];
    $('[data-fb-sw]').style.background = o[2]; $('[data-fb-jk]').textContent = o[1] + ' jacket';
  }

  // ---------------- gift tag ----------------
  var tagTo = $('[data-tag-to]'), tagFrom = $('[data-tag-from]'), tag = $('[data-tag]');
  function renderTag() {
    var to = st.to.trim(), fr = st.from.trim();
    tagTo.textContent = to || toPh(); tagTo.classList.toggle('is-ph', !to);
    tagFrom.textContent = fr || fromPh(); tagFrom.classList.toggle('is-ph', !fr);
  }
  function stamp() {
    if (!st.to.trim()) return;
    tag.classList.remove('is-stamp'); void tag.offsetWidth; tag.classList.add('is-stamp');
    if (reduce) return;
    var fx = $('[data-tag-fx]'); fx.innerHTML = '';
    for (var i = 0; i < 6; i++) { var s = document.createElement('i'); var a = i / 6 * Math.PI * 2 + 0.3; s.style.setProperty('--dx', Math.round(Math.cos(a) * 46) + 'px'); s.style.setProperty('--dy', Math.round(Math.sin(a) * 34) + 'px'); fx.appendChild(s); }
    setTimeout(function () { fx.innerHTML = ''; }, 700);
  }
  function sparklePv() {
    if (reduce) return;
    pv.classList.remove('is-spark'); void pv.offsetWidth; pv.classList.add('is-spark');
    setTimeout(function () { pv.classList.remove('is-spark'); }, 260); stamp();
  }

  // ---------------- badges (step 4) ----------------
  var badgesEl = $('[data-badges]'), lastBadges = '';
  function renderBadges() {
    var b = [];
    if (st.step === 4) {
      if (st.tier === 'classic') b.push(['game', 'Their game ✓']);
      if (st.tier === 'deluxe' || st.tier === 'ultimate') b.push(['voice', 'Your voice at the finale', true]);
      if (st.tier === 'ultimate') { b.push(['duo', 'You in the game']); b.push(['video', '15-s story video']); }
    }
    var key = st.step === 4 ? st.tier : ''; if (key === lastBadges) return; lastBadges = key;
    badgesEl.innerHTML = b.map(function (x, i) {
      return '<li style="--d:' + (i * 60) + 'ms"><span class="vgb-badge__ic">' + BADGE[x[0]] + '</span>' + esc(x[1]) + (x[2] ? '<span class="vgb-wave" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i></span>' : '') + '</li>';
    }).join('');
  }

  // ---------------- price ----------------
  var priceN = $('[data-price-n]'), priceName = $('[data-price-name]'), lastTotal = -1;
  function total() { return (VAR[st.tier] ? VAR[st.tier].price : 0) + (st.rush ? RUSH_P : 0); }
  function renderPrice() {
    var t = total(), v = VAR[st.tier];
    priceName.textContent = (v ? v.title : '') + (st.rush ? ' + Rush' : '');
    if (t !== lastTotal) {
      priceN.textContent = money(t);
      if (lastTotal >= 0 && !reduce) { priceN.classList.remove('is-roll'); void priceN.offsetWidth; priceN.classList.add('is-roll'); }
      lastTotal = t;
    }
    var nl = $('[data-next-l]');
    if (st.step === 4) nl.textContent = 'Checkout · ' + money(t); else nl.textContent = 'Next';
  }
  function etaText() {
    var d = new Date(), f = function (x) { return x.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    var a = new Date(d.getTime() + 864e5), b = new Date(d.getTime() + 2 * 864e5);
    return st.rush ? 'Ready 24 h after your photos — by ' + f(a) + ' if you upload today' : 'Standard: ready 24–48 h after your photos (' + f(a) + '–' + f(b).replace(/^[A-Za-z]+ /, '') + ')';
  }

  // ---------------- render ----------------
  var steps = $$('[data-step-sec]'), progT = $('[data-prog-t]'), liveMsg = $('[data-live-msg]');
  var TITLES = { 1: "Who it's for", 2: 'Their name', 3: 'Make it theirs', 4: 'Pick your edition' };
  function renderWho() { $$('[data-card]').forEach(function (b) { var on = b.getAttribute('data-card') === st.card || (st.card === 'kid' && false); b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on || (!st.card && b.getAttribute('data-card') === 'partner') ? 0 : -1; }); }
  function radio(row, attr, val) { $$('[' + attr + ']', row).forEach(function (b) { var on = b.getAttribute(attr) === val; b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; }); var any = $$('[aria-checked="true"]', row).length; if (!any) { var f = $('[' + attr + ']', row); if (f) f.tabIndex = 0; } }
  function renderStep2() {
    var c = card();
    $('[data-for-label]').textContent = 'For: ' + (st.aud === 'kid' && st.g ? (st.g === 'girl' ? 'Girl' : 'Boy') : st.aud === 'teen' && st.g ? 'Teen ' + st.g : st.aud === 'family' && relName() ? relName() : c.label);
    var to = $('[data-to]'), fr = $('[data-from]');
    to.placeholder = toPh(); fr.placeholder = c.from;
    if (document.activeElement !== to) to.value = st.to;
    if (document.activeElement !== fr) fr.value = st.from;
    $('[data-count]').textContent = st.to.length + '/14';
    $('[data-to-hint]').textContent = c.hint;
    var minor = st.aud === 'kid' || st.aud === 'teen';
    $('[data-gender-row]').hidden = !(st.aud === 'teen' || (st.aud === 'kid' && st.card === 'kid'));
    radio($('[data-gender]'), 'data-g', st.g || (st.gSkip ? '' : '-'));
    $('[data-rel-row]').hidden = st.aud !== 'family'; radio($('[data-rel]'), 'data-r', st.rel);
    $('[data-fromchips-row]').hidden = !minor; $('[data-from-hint]').hidden = minor;
    $$('[data-f]').forEach(function (b) { var v = b.getAttribute('data-f'); b.setAttribute('aria-pressed', v && v === st.from ? 'true' : 'false'); });
  }
  function renderOpts() { OPTS.forEach(function (g) { radio($('[data-row="' + g.k + '"]'), 'data-v', st.opts[g.k]); $$('[data-row="' + g.k + '"] [data-v]').forEach(function (b) { b.setAttribute('data-on', b.getAttribute('aria-checked')); }); }); }
  function renderEds() {
    Object.keys(VAR).forEach(function (k) { VAR[k].el.checked = k === st.tier; VAR[k].el.closest('.vgb-ed').classList.toggle('is-on', k === st.tier); });
    var n = $('[data-nudge]'); if (n) n.textContent = { kid: 'Kids love hearing “a message from ' + (st.from.trim() || 'Mom & Dad') + '”', family: 'Grandma hears the grandkids’ voices', partner: 'Most couples pick Deluxe', teen: 'Most families pick Deluxe', friend: 'Most loved by friends too' }[st.aud] || '';
    $$('[data-proposal]').forEach(function (e) { e.hidden = st.aud !== 'partner'; });
    if (RUSH) {
      RUSH.checked = !!st.rush; RUSH.closest('.vgb-rush').classList.toggle('is-on', !!st.rush);
      $('[data-eta]').textContent = etaText();
      var d = new Date(); $('[data-rush-rec]').hidden = !(d.getMonth() === 11 && d.getDate() >= 19);
    }
  }
  function render() {
    root.setAttribute('data-step', st.step);
    steps.forEach(function (s) { s.hidden = +s.getAttribute('data-step-sec') !== st.step; });
    $$('[data-jump]', $('.vgb-prog')).forEach(function (b) {
      var n = +b.getAttribute('data-jump'); b.classList.toggle('is-done', n < st.step); b.classList.toggle('is-cur', n === st.step);
      b.disabled = n > st.step && !(n === 2 && st.card) && !(n > 2 && st.card && n <= maxReached); if (n === st.step) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
    });
    progT.textContent = 'Step ' + st.step + ' of 4';
    $('[data-back]').style.visibility = st.step > 1 ? 'visible' : 'hidden';
    $('[data-foot-sub]').hidden = st.step !== 4;
    renderWho(); renderStep2(); renderOpts(); renderEds(); renderTag(); renderBadges(); renderPrice(); renderPlay();
  }
  var maxReached = st.step;

  // ---------------- navigation ----------------
  var animT = 0;
  function go(n, opt) {
    opt = opt || {};
    if (n < 1 || n > 4) return;
    if (n > 1 && !st.card) n = 1;
    var from = st.step, out = steps[from - 1];
    st.step = n; maxReached = Math.max(maxReached, n);
    if (!opt.nopush) try { history.pushState({ vgb: n }, '', urlFor(n)); } catch (e) {}
    if (out && from !== n && !reduce) { root.classList.remove('is-anim'); void root.offsetWidth; root.classList.add('is-anim', n > from ? 'is-fwd' : 'is-bwd'); root.classList.remove(n > from ? 'is-bwd' : 'is-fwd'); clearTimeout(animT); animT = setTimeout(function () { root.classList.remove('is-anim'); }, 260); }
    render(); save();
    var h = $('#vgb-h' + n); if (h && !opt.nofocus) try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); }
    $('[data-panel]').scrollTop = 0;
    liveMsg.textContent = 'Step ' + n + ' of 4: ' + TITLES[n];
    ev('step_view', { n: n });
    if (n === 3) postCfg(false);
  }
  function urlFor(n) {
    try { var u = new URL(location.href); u.searchParams.set('step', n); if (st.card) u.searchParams.set('for', st.card); u.searchParams.delete('from'); return u.pathname + u.search; } catch (e) { return location.href; }
  }
  window.addEventListener('popstate', function (e) {
    var n = e.state && e.state.vgb; if (n) go(n, { nopush: true });
  });
  function nameValid() {
    var v = st.to.trim();
    if (!v) { showErr('Add their name (or a nickname)'); return false; }
    return true;
  }
  function showErr(m) {
    var el = $('[data-to-err]'), inp = $('[data-to]');
    el.textContent = m; el.hidden = !m; inp.setAttribute('aria-invalid', m ? 'true' : 'false');
    if (m) { var f = inp.closest('.vgb-inp'); f.classList.remove('is-shake'); void f.offsetWidth; f.classList.add('is-shake'); try { inp.focus({ preventScroll: true }); } catch (x) { inp.focus(); } }
  }
  function next() {
    if (st.step === 1) { if (!st.card) { pickCard('partner'); } return go(2); }
    if (st.step === 2) { if (!nameValid()) return; stamp(); ev('name_entered', {}); document.activeElement && document.activeElement.blur && document.activeElement.blur(); return go(3); }
    if (st.step === 3) return go(4);
    if (st.step === 4) return checkout();
  }
  $('[data-next]').addEventListener('click', next);
  $('[data-back]').addEventListener('click', function () { if (st.step > 1) history.state && history.state.vgb > 1 ? history.back() : go(st.step - 1); });
  root.addEventListener('click', function (e) {
    var j = e.target.closest && e.target.closest('[data-jump]'); if (!j || j.disabled) return;
    var n = +j.getAttribute('data-jump'); if (n !== st.step) go(n);
  });

  // step 1: cards (tap = select + auto-advance after 350 ms)
  var autoT = 0;
  $('[data-who]').addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-card]'); if (!b) return;
    var c = b.getAttribute('data-card');
    pickCard(c); renderWho(); renderTag(); setStill(); postCfg(false); save(); haptic();
    ev('who_select', { aud: c });
    clearTimeout(autoT); autoT = setTimeout(function () { if (st.step === 1) go(2); }, 350);
  });
  function haptic() { try { if (navigator.vibrate) navigator.vibrate(8); } catch (e) {} }

  // step 2: inputs
  var toIn = $('[data-to]'), frIn = $('[data-from]');
  toIn.addEventListener('input', function () {
    var raw = toIn.value, c = cleanName(raw);
    if (c !== raw) { var pos = toIn.selectionStart - (raw.length - c.length); toIn.value = c; try { toIn.setSelectionRange(pos, pos); } catch (e) {} showHint('Letters only — emoji and symbols don’t fit on the street sign.'); }
    else if (c.length >= 14) showHint('14 letters max — a nickname works great.');
    else showHint('');
    st.to = c; $('[data-count]').textContent = c.length + '/14'; renderTag(); postName(); save();
    if (c.trim()) { $('[data-to-err]').hidden = true; toIn.setAttribute('aria-invalid', 'false'); }
  });
  function showHint(m) { var h = $('[data-to-hint]'); h.textContent = m || card().hint; h.classList.toggle('is-warn', !!m); }
  toIn.addEventListener('blur', function () { st.to = st.to.trim(); toIn.value = st.to; renderTag(); if (st.to) stamp(); });
  toIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); frIn.focus(); } });
  frIn.addEventListener('input', function () {
    var raw = frIn.value, c = cleanFrom(raw); if (c !== raw) frIn.value = c;
    st.from = c; renderTag(); renderStep2(); save();
  });
  frIn.addEventListener('blur', function () { st.from = st.from.trim(); frIn.value = st.from; renderTag(); });
  frIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); next(); } });
  $('[data-fromchips]').addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-f]'); if (!b) return;
    var v = b.getAttribute('data-f'); haptic();
    if (!v) { st.from = ''; frIn.value = ''; renderTag(); renderStep2(); save(); frIn.focus(); return; }
    st.from = v; frIn.value = v; renderTag(); renderStep2(); save(); stamp();
  });
  $('[data-gender]').addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-g]'); if (!b) return;
    st.g = b.getAttribute('data-g'); st.gSkip = !st.g; if (!st.colTouched) st.opts.collectible = autoCol();
    renderStep2(); setStill(); postCfg(false); save(); haptic();
  });
  $('[data-rel]').addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-r]'); if (!b) return;
    st.rel = st.rel === b.getAttribute('data-r') ? '' : b.getAttribute('data-r'); renderStep2(); renderTag(); save(); haptic();
  });

  // step 3: option chips + surprise
  var heard = false;
  $('[data-opts]').addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-k]'); if (!b) return;
    var k = b.getAttribute('data-k'), v = b.getAttribute('data-v');
    st.opts[k] = v; if (k === 'collectible') st.colTouched = true;
    renderOpts(); setStill(); updFb(); postCfg(false); save(); haptic();
    if (k === 'music') { post({ type: 'vlsound', on: true }); if (!heard) { heard = true; var h = $('[data-hear]'); if (h) h.textContent = mode === 'live' ? '· sound on — tap the preview if you can’t hear it' : '· music plays in the live game'; } }
    liveMsg.textContent = 'Preview: ' + optLabel(k, v);
    ev('option_change', { key: k });
  });
  $('[data-surprise]').addEventListener('click', function () {
    OPTS.forEach(function (g) {
      if (g.k === 'music') return;
      var choices = g.o.filter(function (o) { return o[0] !== st.opts[g.k]; }); st.opts[g.k] = choices[Math.floor(Math.random() * choices.length)][0];
    });
    st.colTouched = true; renderOpts(); setStill(); updFb(); postCfg(false); save(); sparklePv(); haptic();
    OPTS.forEach(function (g) { var r = $('[data-row="' + g.k + '"]'), on = r && $('[aria-checked="true"]', r); if (on) r.scrollTo({ left: on.offsetLeft - r.offsetLeft - 16, behavior: reduce ? 'auto' : 'smooth' }); });
    liveMsg.textContent = 'Preview: ' + optLabel('collectible', st.opts.collectible) + ', ' + optLabel('tree', st.opts.tree) + ' tree, ' + optLabel('sky', st.opts.sky);
    ev('surprise_me', {});
  });
  // arrow keys inside any radiogroup
  root.addEventListener('keydown', function (e) {
    if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
    var b = e.target.closest && e.target.closest('[role="radio"]'); if (!b || b.tagName !== 'BUTTON') return;
    var all = $$('[role="radio"]', b.closest('[role="radiogroup"]')), i = all.indexOf(b) + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1);
    var n = all[(i + all.length) % all.length]; e.preventDefault(); n.focus();
    if (n.hasAttribute('data-card')) { pickCard(n.getAttribute('data-card')); renderWho(); renderTag(); setStill(); postCfg(false); save(); } else n.click();
  });

  // step 4: edition + rush
  $('[data-eds]').addEventListener('change', function (e) {
    if (!e.target.value || !VAR[e.target.value]) return;
    st.tier = e.target.value; renderEds(); renderBadges(); renderPrice(); save(); haptic();
    ev('edition_select', { tier: st.tier });
  });
  if (RUSH) RUSH.addEventListener('change', function () { st.rush = RUSH.checked; renderEds(); renderPrice(); save(); ev('rush_toggle', { on: st.rush }); });

  // ---------------- step 3: "What they'll play" strip (3 short muted loops for the picked audience) ----------------
  var PLAY = null; try { PLAY = JSON.parse($('[data-play-cfg]').textContent); } catch (e) {}
  var playRow = $('[data-play-row]'), playSet = '', playVis = false, playIO = null;
  var SCN = [['sleigh', 'Sleigh ride'], ['reindeer', 'Reindeer flight'], ['lake', 'Frozen lake']];
  var saveData = false; try { saveData = !!(navigator.connection && navigator.connection.saveData); } catch (e) {}
  function playSetFor() { return st.aud === 'family' ? 'family' : st.aud === 'kid' ? (st.g === 'boy' || (!st.g && autoCol() === 'stars') ? 'kidsboy' : 'kids') : st.aud === 'teen' ? 'kidsboy' : 'partner'; }
  function playVids(on) {
    $$('video', playRow).forEach(function (v) {
      if (on && !reduce && !saveData) { if (v.preload === 'none') { v.preload = 'auto'; try { v.load(); } catch (e) {} } try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
      else try { v.pause(); } catch (e) {}
    });
  }
  function renderPlay() {
    if (!PLAY || !playRow) return;
    var set = playSetFor(), c = PLAY[set] || PLAY.partner;
    if (set !== playSet) {
      playSet = set;
      playRow.innerHTML = SCN.map(function (x) {
        var u = c[x[0]];
        return '<figure class="vgb-play__t" role="listitem"><div class="vgb-play__v"><img src="' + u[2] + '" alt="" width="300" height="400" loading="lazy" decoding="async">' +
          (reduce || saveData ? '' : '<video muted loop playsinline webkit-playsinline disablepictureinpicture preload="none" aria-label="' + esc(x[1]) + ' (demo clip)" width="300" height="400"><source src="' + u[0] + '" type="video/mp4"><source src="' + u[1] + '" type="video/webm"></video>') +
          '</div><figcaption>' + esc(x[1]) + '</figcaption></figure>';
      }).join('');
      $$('video', playRow).forEach(function (v) {
        v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
        v.addEventListener('playing', function () { v.parentNode.classList.add('is-on'); });
        v.addEventListener('timeupdate', function () { if (v.currentTime > 0.05) v.parentNode.classList.add('is-on'); });
      });
    }
    if (!playIO && 'IntersectionObserver' in window) {
      playIO = new IntersectionObserver(function (es) { playVis = es[0].isIntersecting; playVids(playVis && st.step === 3); }, { threshold: 0.15 });
      playIO.observe(playRow);
    }
    playVids(st.step === 3 && (playVis || !playIO));
  }

  // ---------------- checkout ----------------
  var busy = false;
  function props() {
    var c = card(), p = {};
    p.For = st.aud === 'kid' ? 'Kid' : st.aud === 'family' ? 'Family' + (relName() ? ' (' + relName() + ')' : '') : c.label;
    p['Recipient name'] = st.to.trim();
    if (st.from.trim()) p.From = st.from.trim();
    if (st.g) p.Gender = st.g === 'girl' ? 'Girl' : 'Boy';
    OPTS.forEach(function (g) { p[g.prop] = optLabel(g.k, st.opts[g.k]); });
    var code = Object.keys(DEF).map(function (k) { return k + '=' + st.opts[k]; });
    code.push('audience=' + st.aud); if (st.g) code.push('gender=' + st.g); if (st.rel) code.push('rel=' + st.rel);
    code.push('to=' + st.to.trim().replace(/[;=]/g, '')); if (st.from.trim()) code.push('from=' + st.from.trim().replace(/[;=]/g, ''));
    p._vlcfg = code.join(';');
    return p;
  }
  function toast(m, ms) { var t = $('[data-toast]'); t.textContent = m; t.hidden = false; clearTimeout(t._t); t._t = setTimeout(function () { t.hidden = true; }, ms || 2500); }
  function checkout() {
    if (busy) return;
    if (!st.to.trim()) { go(2); setTimeout(function () { showErr('Add their name (or a nickname)'); }, 60); return; }
    var v = VAR[st.tier]; if (!v) return;
    busy = true; var btn = $('[data-next]'); btn.disabled = true; btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true');
    var items = [{ id: v.id, quantity: 1, properties: props() }];
    if (st.rush && RUSH) items.unshift({ id: +RUSH.getAttribute('data-vid'), quantity: 1 });   // Shopify lists the last-added line first: Rush first so the game is line 1
    ev('checkout_click', { tier: st.tier, rush: !!st.rush });
    sset(KEY, st);
    var J = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var fail = function () { busy = false; btn.disabled = false; btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); toast('Something went wrong — opening your cart instead.', 2000); setTimeout(function () { location.href = CFG.cart || '/cart'; }, 1200); };
    fetch(CFG.cartClear || '/cart/clear.js', { method: 'POST', headers: J, body: '{}', credentials: 'same-origin' })
      .then(function () { return fetch(CFG.cartAdd || '/cart/add.js', { method: 'POST', headers: J, body: JSON.stringify({ items: items }), credentials: 'same-origin' }); })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { location.href = '/checkout'; })
      .catch(fail);
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) { busy = false; var b = $('[data-next]'); b.disabled = false; b.classList.remove('is-busy'); } });

  // ---------------- close / leave ----------------
  var sheet = $('[data-sheet]');
  function leave() {
    ev('builder_exit', { step: st.step });
    var ref = document.referrer, same = false; try { same = ref && new URL(ref).origin === location.origin && new URL(ref).pathname !== location.pathname; } catch (e) {}
    location.href = same ? ref : '/';
  }
  $('[data-close]').addEventListener('click', function () {
    if (st.step === 1 && !dirty) return leave();
    sheet.hidden = false; setTimeout(function () { $('[data-sheet-no]', sheet.querySelector('.vgb-sheet__b')).focus(); }, 30);
  });
  $$('[data-sheet-no]').forEach(function (b) { b.addEventListener('click', function () { sheet.hidden = true; $('[data-close]').focus(); }); });
  $('[data-sheet-yes]').addEventListener('click', function () { sset(KEY, st); leave(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) { sheet.hidden = true; $('[data-close]').focus(); } });
  $('[data-restart]').addEventListener('click', function () {
    sdel(KEY); st = { v: 1, step: 1, card: '', aud: 'partner', g: '', rel: '', to: '', from: '', opts: Object.assign({}, DEF), colTouched: false, tier: VAR.deluxe ? 'deluxe' : st.tier, rush: false, at: 0 };
    dirty = false; $('[data-resume]').hidden = true; maxReached = 1; setStill(); postCfg(true); go(1);
  });

  // ---------------- keyboard / visual viewport ----------------
  var vv = window.visualViewport, maxH = innerHeight;
  function fit() {
    var h = vv ? vv.height : innerHeight; maxH = Math.max(maxH, innerHeight);
    root.style.setProperty('--vgb-h', Math.round(h) + 'px');
    root.style.transform = vv && vv.offsetTop > 0 ? 'translateY(' + Math.round(vv.offsetTop) + 'px)' : '';
    var typing = /^(INPUT|TEXTAREA)$/.test((document.activeElement || {}).tagName || '');
    root.classList.toggle('is-kbd', typing && h < 0.75 * maxH);
  }
  if (vv) { vv.addEventListener('resize', fit); vv.addEventListener('scroll', fit); }
  window.addEventListener('resize', fit);
  document.addEventListener('focusin', function () { setTimeout(fit, 60); }); document.addEventListener('focusout', function () { setTimeout(fit, 60); });

  // ---------------- boot ----------------
  try { history.replaceState({ vgb: st.step }, '', urlFor(st.step)); } catch (e) {}
  fit(); render(); initPreview();
  if (resumed) { $('[data-resume]').hidden = false; toast('Welcome back — picked up where you left off', 2500); ev('resume', {}); }
  ev('builder_open', { entry: (function () { try { return document.referrer ? new URL(document.referrer).pathname : 'direct'; } catch (e) { return 'direct'; } })() });
  if (st.card && QS.get('for')) dirty = true;
  window.__vgb = { state: function () { return JSON.parse(JSON.stringify(st)); }, mode: function () { return mode; }, props: props, go: go };
})();
